// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';

const wiz = new Wiz({ appId: 'page.macros.detail', namespace: 'macros.detail' });
@AngularComponent({
  selector: 'wiz-page-macros-detail',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class PageMacrosDetailComponent {}

export default PageMacrosDetailComponent;
